import { connect } from 'react-redux'
import * as action from '../../state/quotation/action'
import * as selector from '../../state/quotation/selector'
import ImplantTreatmentQuotation from '../quotation/ImplantTreatmentQuotation'
import * as customerSelector from '../../../customer/state/detail/selector'
import { PRODUCT_TYPE_IMPLANTS } from '../../state/quotation/const'

const mapStateToProps = (state, props) => {
    return {
        treatmentQuotation: selector.selectTreatmentQuotation(state),
        isPreviewModalOpen: selector.selectIsPreviewModalOpen(state),
        isValid: selector.selectIsImplantTreatmentQuotationValid(state),
        customer: customerSelector.selectCustomer(state),
        productType: PRODUCT_TYPE_IMPLANTS,
    }
}

const mapDispatchToProps = {
    findOrCreateTreatmentQuotation: action.findOrCreateTreatmentQuotation,
    changeTreatmentQuotation: action.changeTreatmentQuotation,
    saveImplantTreatmentQuotation: action.saveImplantTreatmentQuotation,
    openPreviewModal: action.openPreviewModal,
    closePreviewModal: action.closePreviewModal,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImplantTreatmentQuotation)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/ImplantTreatmentQuotationWidgetContainer.js